import { faBox, faCoins } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from '@redux';
import { getSummaryInventories } from '@redux/inventories/actions';
import { Card, Col, Row } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { DynamicObjectType } from 'types/commons';
import { separateThousand } from 'utils/formattedString';

const SummaryCard = () => {
  const dispatch = useDispatch();

  const [summary, setSummary] = useState<DynamicObjectType>({});

  useEffect(() => {
    dispatch(
      getSummaryInventories({
        data: {},
      }),
    ).then((res) => {
      if (res?.payload) {
        setSummary(res.payload);
      }
    });
  }, []);

  const SUMMARIES = useMemo(() => {
    return [
      {
        title: 'Total variants',
        value: summary?.totalVariantSku,
        icon: faBox,
        key: 'totalVariantSku',
        bgColor: '#6852D3B2',
      },
      {
        title: 'Has stock',
        value: summary?.hasStock,
        icon: faCoins,
        key: 'hasStock',

        bgColor: '#FFC70080',
      },
      {
        title: 'Out of stock',
        value: summary?.outStock,
        icon: faBox,
        key: 'outStock',
        bgColor: '#FFAFA3',
      },
    ];
  }, [summary]);

  return (
    <SummaryStyle>
      <Row gutter={[20, 20]}>
        {SUMMARIES.map((summary) => {
          return (
            <Col span={8}>
              <SummaryItemStyle key={summary.key} background={summary.bgColor}>
                <Card>
                  <div className="d-flex space-between">
                    <div>
                      <div className="text-title-gray">{summary.title}</div>
                      <div className="fw-600">
                        {separateThousand(summary.value)}
                      </div>
                    </div>
                    <div className="right-content">
                      <FontAwesomeIcon icon={summary.icon} />
                    </div>
                  </div>
                </Card>
              </SummaryItemStyle>
            </Col>
          );
        })}
      </Row>
    </SummaryStyle>
  );
};

export default SummaryCard;

const SummaryStyle = styled.div`
  margin-bottom: 20px;
`;

const SummaryItemStyle = styled.div<{ background?: string }>`
  .right-content {
    border-radius: 4px;
    width: 30px;
    height: 30px;
    color: #fff;
    padding: 7px;
    background: ${({ background }) => background};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
